<template lang="pug">
  main(class="main-grid")
    // Left panel content
    aside(class="sidebar courses-available")
      h2 Check the Tweets
      ul
        li Connect with <a href="https://twitter.com/TimsSTEMCells"><strong>Tim's S.T.E.M. cells on Twitter</strong></a>

    // Right panel content
    div(class="content-container")
      section(class="main-container just-text")
        div
          h2 Interested in taking or teaching a course?

          h3 Take a course
          p If you are interested in taking our Circuits 1 course, you can go directly to <a href="https://circuits1.hvullc.com">Circuits 1 at HVU</a> and sign up for access today.

          h3 Teach from an existing course
          p If you are interested in using our Circuits 1 course to teach Circuits to a group of your students, please send an email to <a href="mailto:feedback@mathsmithllc.com">feedback@mathsmithllc.com</a> and ask for &ldquo;Group Leader&rdquo; access.

          h3 Create a course
          p We are very excited to have S.T.E.M. course creators try out our HVU learning environment and our MathSmith Canvas app for administering practice problems. Please send an email to <a href="mailto:feedback@mathsmithllc.com">feedback@mathsmithllc.com</a> and ask for &ldquo;Administrator&rdquo; access and assistance in setting up a course.
</template>

<script>
export default {
  name: "Contact"
};
</script>
